import { render, staticRenderFns } from "./SchoolTeacherAwayControl.vue?vue&type=template&id=66cb7b06&scoped=true&"
import script from "./SchoolTeacherAwayControl.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherAwayControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb7b06",
  null
  
)

export default component.exports